import { Navigate } from 'react-router-dom';

export default function Users() {
  return <Navigate to="/settings?tab=users" replace />;
}
